import { render, staticRenderFns } from "./CategoryChangeActivationType.vue?vue&type=template&id=065d38c0&"
import script from "./CategoryChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./CategoryChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports